import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';

const MB_SVG_BrokenFile = React.memo((props: {
    /**
     * The size of the component.
     */
    size?: number,

    /**
     * The color of the component.
     */
    color?: string,

    /**
     * The style of the component's container.
     */
    containerStyle?: StyleProp<ViewStyle>
}) => {
    return (
        <View style={props.containerStyle}>
            <Svg
                width={props.size ?? 97.96}
                height={props.size ? (props.size * (122.88 / 97.96)) : 122.88}
                x="0px"
                y="0px"
                viewBox="0 0 97.96 122.88"
                fill={props.color ?? '#ff0000'}
            >
                <Path d="M66.77.69C66.31.28 65.66 0 65.02 0c-.14 0-.28 0-.41.05H5.88c-1.57 0-3.04.64-4.1 1.7a5.75 5.75 0 00-1.71 4.1v54.98l-.07.05v6.81l.07-.04v.64c4.36-2.85 8.22-5.6 12.63-8.26l15.44 18.38L45.6 57.63 61 75.96l23.89-16.42 5.42 3.73 7.54 5.18V33.86c.05-.23.09-.41.09-.64 0-.78-.37-1.47-.87-1.98L67.07.88a.509.509 0 00-.21-.18l-.09-.01zM7.61 56.71V8.24c0-.18.05-.32.18-.42.09-.09.23-.18.42-.18h52.53v20.92c0 2.17.88 4.74 2.3 6.17 1.43 1.43 4.45 2.6 6.62 2.6h20.66v19.83l-5.42-3.73-22.55 15.5-16.73-19.92L28.16 69.8l-14-16.67-6.55 3.58zM90.33 82.9l-5.42-3.73-28.16 19.35-11.12-13.24-17.49 20.81L8.05 82.17l-.46.22c-.06 10.89-.15 32.35.21 32.71.1.13.28.18.42.18 7.72 0 81.25.35 81.79-.18.13-.09.33-.27.33-.41V82.9h-.01zM.07 85.89l-.07.04v-5.08l9.5-5.57 18.65 22.2 17.48-20.8L58.08 91.5l26.83-18.43 5.42 3.73 7.54 5.18v35.11c0 1.61-.64 3.04-1.7 4.1a5.782 5.782 0 01-4.1 1.7H5.88a5.74 5.74 0 01-4.1-1.7 5.75 5.75 0 01-1.71-4.1v-31.2zM67.6 27.97V8.94l21.43 21.7H70.27c-.74 0-1.38-.32-1.89-.78-.46-.46-.78-1.16-.78-1.89z" />
            </Svg>
        </View>
    );
});

export { MB_SVG_BrokenFile };
